import React, { useState, useEffect, useRef } from 'react';
import JessibucaPlayer from '@/components/JessibucaPlayer';
import styles from './style.less';
import classnames from 'classnames';
import { useRequest, request, useLocation } from 'umi';
import { useUpdateEffect } from 'ahooks';
import dayjs from 'dayjs';
import { DatePicker, Space } from 'antd';
import screenfull from 'screenfull';
import { getPrefix } from '@/util';

let apiPrefix = 'https://open.mokan.cn';
const list = [1, 2, 3];
const Playback = () => {
  const location = useLocation();
  const {
    type,
    deviceId,
    serialNumber,
    timestamp,
    clientCode,
    sign,
    bindTime,
    hideVoiceBtn,
  } = location.query;

  const playerRef = useRef();
  const [active, setActive] = useState(false);
  const [isMute, setIsMute] = useState(true);
  const [isHD, setIsHD] = useState(false);
  const [url, setUrl] = useState('');
  const [date, setDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [playbackDates, setPlaybackDates] = useState([]);
  const [playingDate, setPlayingDate] = useState('');
  const [loading, setLoading] = useState(true);
  const [isPause, setIsPause] = useState(false);
  const playerContainer = useRef();
  const [isFullscreen, setIsFullscreen] = useState(screenfull.isFullscreen);
  //倍速
  const [speed, setSpeed] = useState(null);
  const [speedListShow, setSpeedListShow] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [hasMore, sethasMore] = useState(false); // 列表是否有更多数据
  const [loadLock, setloadLock] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true); // 新增状态来跟踪首次加载
  const [deviceInfo, setDeviceInfo] = useState(null); //设备信息

  //将时间戳转换为时间格式
  function formatUnixToDate(startUnix) {
    const unixTimestamp = Number(startUnix); // 将字符串转换为数字
    const originalDate = dayjs(unixTimestamp); // 使用 dayjs 反解析为日期对象
    return originalDate.format('YYYY-MM-DD'); // 返回格式化的日期字符串
  }
  useUpdateEffect(() => {
    if (playerRef.current) {
      if (active) {
        playerRef.current.setRotate(270);
      } else {
        playerRef.current.setRotate(0);
      }
      playerRef.current.resize();
    }
  }, [active]);

  if (type === 'test') {
    apiPrefix = 'https://test-open.mokan.cn';
  }

  const tempObj = {};
  if (serialNumber) {
    tempObj.serialNumber = serialNumber;
  } else if (deviceId) {
    tempObj.deviceId = deviceId;
  }

  const _getPlayBackList = (startTime) => {
    if (loadLock) return;
    setloadLock(true);

    // 计算开始时间
    let startUnix;
    if (initialLoad) {
      // 如果是首次加载，且bindTime存在且日期与date相同，则使用bindTime，否则使用date的时间戳
      const dateOnly = dayjs(date, 'YYYY-MM-DD');
      const bindTimeDateOnly = bindTime
        ? dayjs(Number(bindTime)).startOf('day')
        : null;
      if (bindTimeDateOnly && dateOnly.isSame(bindTimeDateOnly)) {
        startUnix = bindTime;
      } else {
        startUnix = dateOnly.unix() * 1000;
      }
      setInitialLoad(false); // 设置完成后更新状态，避免后续再次执行
    } else {
      const dateOnly = dayjs(date, 'YYYY-MM-DD');
      const bindTimeDateOnly = bindTime
        ? dayjs(Number(bindTime)).startOf('day')
        : null;
      if (bindTimeDateOnly && dateOnly.isSame(bindTimeDateOnly)) {
        startUnix = bindTime;
      } else {
        startUnix = dateOnly.unix() * 1000;
      }
    }
    let endTime = null;
    if (bindTime && startUnix == bindTime) {
      // 计算第二天的零晨 方式一
      // const date = dayjs(formatUnixToDate(startUnix));
      // const nextDayMidnight = date.add(1, 'day').startOf('day');
      // const unixTimestamp = nextDayMidnight.unix() * 1000;
      // endTime = unixTimestamp;

      /// 计算第二天的零晨 方式二
      endTime = dayjs(Number(startUnix)).add(1, 'day').startOf('day').valueOf();
    } else {
      endTime = startUnix + 24 * 60 * 60 * 1000;
    }

    request(`${apiPrefix}/openapi/video/getPlayBackList`, {
      method: 'post',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params: {
        ...tempObj,
        startTime: startTime ? startTime : String(startUnix),
        endTime: String(endTime), // 使用计算的 endTime,
      },
    })
      .then((response) => {
        setloadLock(false);
        setPlaybackDates(
          startTime
            ? [...playbackDates, ...response.data.times]
            : response.data.times,
        );
        setLoading(false);
        sethasMore(response.data.times.length >= 63);
      })
      .catch(() => {
        setLoading(false);
        setloadLock(false);
      });
  };

  const _playback = ({ startTime, speed }) => {
    return request(`${apiPrefix}/openapi/video/startPlayBack`, {
      method: 'post',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params: {
        ...tempObj,
        startTime,
        force: true,
        voice: true,
        speed,
      },
    });
  };

  // 切换日期
  useEffect(() => {
    setPlaybackDates([]);
    sethasMore(false);
    setLoading(true);
    _getPlayBackList();
  }, [date]);

  const disabledDate = (current) => {
    // 假设 bindTime 是一个 Unix 时间戳（以毫秒为单位）
    let startTime = formatUnixToDate(bindTime);
    let startDay = dayjs(startTime); // 将 startTime 转换为 dayjs 对象
    let today = dayjs().endOf('day'); // 获取今天的结束时间
    // 禁用 startTime 之前和今天之后的日期
    return (
      current &&
      (current.isBefore(startDay, 'day') || current.isAfter(today, 'day'))
    );
  };
  // 杰峰设备回放超过63段时，表示还有下一页，需滚动加载
  const handleScroll = (e) => {
    if (
      Math.ceil(e.currentTarget.scrollTop + e.currentTarget.clientHeight) >=
        e.currentTarget.scrollHeight - 20 &&
      hasMore
    ) {
      _getPlayBackList(playbackDates[playbackDates.length - 1].end);
    }
  };
  function getDeviceInfo() {
    return request(`${apiPrefix}/openapi/ai/getDeviceInfo`, {
      method: 'get',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params: tempObj,
    });
  }
  useEffect(() => {
    if (serialNumber || deviceId) {
      getDeviceInfo().then((res) => {
        setDeviceInfo(res.data);
      });
    }
  }, []);
  return (
    <div className={styles.container}>
      <div className="container-box">
        <div className="player-box" ref={playerContainer}>
          <div
            className={classnames('play', {
              active,
            })}
          >
            {serialNumber && <div className="tip">设备号： {serialNumber}</div>}
            <div className="player">
              <JessibucaPlayer defaultMute={true} url={url} ref={playerRef} />
            </div>
          </div>
          <div
            className={classnames('bar', {
              active,
            })}
          >
            <div className="left"></div>
            <div className="right">
              {getPrefix(deviceInfo?.deviceType) !== 'JF_' &&
              getPrefix(deviceInfo?.deviceType) !== 'OK_' &&
              url ? (
                <>
                  {speed ? (
                    <span
                      className="speed colorBlue pdf4"
                      onClick={() => {
                        setSpeedListShow(true);
                      }}
                    >
                      {speed + 'X'}
                    </span>
                  ) : (
                    <span
                      className="speed colorFFF"
                      onClick={() => {
                        setSpeedListShow(speedListShow ? false : true);
                      }}
                    >
                      倍速
                    </span>
                  )}
                </>
              ) : null}
              {speedListShow ? (
                <div className="speedList">
                  <ul>
                    {list.map((item) => {
                      return (
                        <li
                          onClick={() => {
                            setSpeed(item);
                            setSpeedListShow(false);

                            _playback({
                              startTime: startTime,
                              speed: item || 1,
                            }).then((response) => {
                              setUrl(response.data.flvs);
                              setIsPause(true);
                            });
                          }}
                          className={speed === item ? 'colorBlue' : ''}
                        >
                          {item}X
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : null}
              {!hideVoiceBtn && (
                <>
                  {isMute ? (
                    <img
                      onClick={() => {
                        playerRef.current.cancelMute();
                        setIsMute(false);
                      }}
                      className="icon"
                      src={require('@/assets/mute.png')}
                      alt=""
                    />
                  ) : (
                    <img
                      onClick={() => {
                        playerRef.current.mute();
                        setIsMute(true);
                      }}
                      className="icon"
                      src={require('@/assets/voice.png')}
                      alt=""
                    />
                  )}
                </>
              )}
              {isFullscreen ? (
                <img
                  className="icon"
                  src={require('@/assets/window.png')}
                  onClick={() => {
                    screenfull.exit();
                    setIsFullscreen(false);
                  }}
                />
              ) : (
                <img
                  className="icon"
                  src={require('@/assets/screenfull.png')}
                  onClick={() => {
                    screenfull.request(playerContainer.current);
                    setIsFullscreen(true);
                  }}
                />
              )}
            </div>
          </div>
        </div>
        <div className="playback-box">
          <div className="paddingBox">
            <div className="choose-date">
              <div className="choose">
                {/* <LeftOutlined
                className="icon"
                onClick={() => {
                  setDate(
                    dayjs(date, 'YYYY-MM-DD')
                      .subtract(1, 'days')
                      .format('YYYY-MM-DD'),
                  );
                }}
              />
              <span className="date">{date}</span>
              <RightOutlined
                className="icon"
                onClick={() => {
                  setDate(
                    dayjs(date, 'YYYY-MM-DD')
                      .add(1, 'days')
                      .format('YYYY-MM-DD'),
                  );
                }}
              /> */}
                <DatePicker
                  defaultValue={dayjs(date, 'YYYY-MM-DD')}
                  onChange={(date, dateString) => {
                    setDate(dateString);
                  }}
                  disabledDate={disabledDate}
                />
              </div>
              <span className="count">
                当天共计{playbackDates.length}段回放
              </span>
            </div>
          </div>

          <div className="scroller">
            <div className="scroll" onScroll={(e) => handleScroll(e)}>
              {
                !loading ? (
                  playbackDates.length > 0 ? (
                    playbackDates.map((item, index) => {
                      return (
                        <div
                          className={classnames([
                            'item',
                            {
                              active:
                                `${date}-${item}-${index}` === playingDate,
                            },
                          ])}
                          onClick={() => {
                            setPlayingDate(`${date}-${item}-${index}`);
                            setStartTime(item.start);
                            _playback({
                              startTime: item.start,
                              speed: speed || 1,
                            }).then((response) => {
                              setUrl(response.data.flvs);
                              setTimeout(() => {
                                if (isMute) {
                                  playerRef.current.mute();
                                } else {
                                  playerRef.current.cancelMute();
                                }
                              }, 500);
                              setIsPause(true);
                            });
                          }}
                        >
                          <Space>
                            <span className="text">
                              {dayjs
                                .unix(parseInt(item.start / 1000))
                                .format('HH:mm:ss')}
                              ～
                              {dayjs
                                .unix(parseInt(item.end / 1000))
                                .format('HH:mm:ss')}
                            </span>
                            {`${date}-${item}-${index}` === playingDate ? (
                              <span className="text">回放中</span>
                            ) : null}
                          </Space>
                        </div>
                      );
                    })
                  ) : (
                    <div className="empty">暂无回放视频</div>
                  )
                ) : null
                // <div className="loading">加载中...</div>
              }
              {hasMore || loading ? (
                <div className="loading">加载中...</div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default () => {
  return <Playback />;
  // if (navigator.userAgent.indexOf('UCBrowser') > -1) {
  //   return (
  //     <NoticeBar theme="danger">
  //       由于UC不支持播放器播放，请使用其他播放器打开当前地址
  //     </NoticeBar>
  //   );
  // } else {
  //   return <Playback />;
  // }
};
